/** @format */

import React, { useCallback, useEffect, useState } from "react";
import { useLocale } from "../../../i18n/hooks";
import { ResourceCard, Spec, SpecItemData } from "../../../types";

type Props = {
  resource: ResourceCard;
};

const SpecItemBadge: React.FC<Props> = ({ resource }) => {
  const locale = useLocale();
  const [specItemTitle, setSpecItemTitle] = useState<string>();

  const getNextTitle = useCallback(
    (curSelected: string, specItem: Spec[]) => {
      const nextSpec = specItem[+curSelected.charAt(0)].children;
      if (nextSpec === undefined || curSelected.length === 1) {
        setSpecItemTitle(specItem[+curSelected].title[locale] ?? "");
        return;
      }

      getNextTitle(curSelected.substring(2, curSelected.length), nextSpec);
    },
    [locale, setSpecItemTitle],
  );

  useEffect(() => {
    if (resource.SpecItem) {
      const Qualification = resource.Qualification;
      const SubjectId = resource.Subject.id;
      let specItem: SpecItemData | undefined;

      if (Qualification !== undefined && SubjectId !== undefined) {
        try {
          let formattedQual = Qualification.replace(
            /([a-z0-9])([A-Z])/g,
            "$1-$2",
          ).toLowerCase();
          let formattedSubject = SubjectId.toLowerCase();
          const data = require(`../../../json/specItems/${formattedQual}-${formattedSubject}.json`);

          specItem = data;
        } catch {
          console.log("failed to fetch Spec Item");
        }

        if (specItem) {
          getNextTitle(resource.SpecItem, specItem.spec);
        }
      }
    }

    return () => {
      setSpecItemTitle(undefined);
    };
  }, [
    resource.Qualification,
    resource.Subject,
    resource.SpecItem,
    getNextTitle,
  ]);

  return (
    <>
      {specItemTitle && (
        <span key={resource.SpecItem}>
          <small
            className={`card-badge bg-dark d-inline-block px-2 rounded-end shadow-sm text-white bg-gray`}
            title={specItemTitle}
          >
            {specItemTitle}
          </small>
          <br />
        </span>
      )}
    </>
  );
};

export default SpecItemBadge;
